
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/category/[uri]",
      function () {
        return require("private-next-pages/news/category/[uri].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/category/[uri]"])
      });
    }
  